import {
  BodyType,
  detectType,
  MessageFile,
} from "@/components/ui/message/message-file"
import { MessageImage } from "@/components/ui/message/message-image"
import { MessagePdf } from "@/components/ui/message/message-pdf"
import {
  MessageAudio,
  MessageVideo,
} from "@/components/ui/message/message-media"
import { MessageText } from "@/components/ui/message/message-text"
import { useMessageContext } from "@/components/ui/message/message"

const MessageBody = ({
  forwarded = false,
  reply = false,
  ...props
}: {
  type?: BodyType | undefined
  forwarded?: boolean
  reply?: boolean
  content?: string
  contentOffset?: number
  highlightTerms?: string[]
}) => {
  const { message } = useMessageContext()
  const type = props.type || detectType(message?.fileName)
  // Image message
  if (type) {
    if (type === "image") {
      return <MessageImage forwarded={forwarded} reply={reply} />
    }

    if (type === "pdf") {
      return <MessagePdf forwarded={forwarded} reply={reply} />
    }

    // Video message
    if (type === "video") {
      return (
        <MessageVideo forwarded={forwarded} controls={true} reply={reply} />
      )
    }

    // Audio message
    if (type === "audio") {
      return <MessageAudio forwarded={forwarded} reply={reply} />
    }

    // File attachment
    return (
      <MessageFile
        fileType={type}
        fileUrl={message.url}
        showDownload={true}
        forwarded={forwarded}
        reply={reply}
      />
    )
  }

  // Text message (default)
  return (
    <MessageText
      content={props.content}
      contentOffset={props.contentOffset}
      highlightTerms={props.highlightTerms}
      forwarded={forwarded}
      reply={reply}
    />
  )
}

export { MessageBody }
